export const transalateTransactionStatus: { [key: string]: string } = {
  0: "Cancelada",
  1: "Pagada",
  2: "Pendiente",
  3: "Reembolso Pendiente",
  4: "Reembolsada",
  5: "Cuenta Abierta",
  8: "Pendiente de Validación",
};
